import APIGet from '../../../API/APIGet';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppConfig from '../../../AppConfig';
import DateRangeLabel from '../../../Components/DateRangeLabel';

export const IncentiveTab = ({ travelerId }) => {
	const [incentivePrograms, setIncentivePrograms] = useState([]);

	useEffect(() => {
		APIGet('travelers/' + travelerId + '/incentives').then(response => {
			setIncentivePrograms(response.data || []);
		});
	}, [travelerId]);
	return (
		<div className="table-container" style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
			<table className="table is-fullwidth is-hoverable travelers-table">
				<thead className="table-header-travelers">
					<tr>
						<th width="40%" className="travelers-table-header-left">
							Program ({incentivePrograms.length})
						</th>
						<th width="20%">วันเดินทาง</th>
						<th width="20%">ผู้เดินทาง (คน)</th>
						<th width="20%">ลูกค้า</th>
					</tr>
				</thead>
				<tbody>
					{incentivePrograms.length > 0 ? (
						incentivePrograms.map(item => (
							<tr key={item.id}>
								<td>
									<Link className="travelers-row-link" to={AppConfig.appPath + '/programs/incentive/' + item.id}>
										{item.title}
									</Link>
								</td>
								<td>
									<DateRangeLabel startDate={item.startDate} endDate={item.endDate} />
								</td>
								<td>{item.numberOfCustomers}</td>
								<td>{item.company ? item.company.name : ''}</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="4" style={{ textAlign: 'center' }}>
								ไม่มีข้อมูล
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
